<template>
  <v-row no-gutters class="pa-3">
    <v-col>
      <v-card-text>
        <v-row>
          <v-col md="6" class="d-flex" cols="12" sm="4">
            <v-autocomplete
              v-model="inputs.participant"
              :items="filteredParticipants"
              :multiple="true"
              :clearable="true"
              :small-chips="true" dense
              :label="$tc('common.form.select-participants')"
              @change="filteredScores_()" hide-details
              outlined
            >
            <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @click="selectAllPart">
                  <v-list-item-action>
                    <v-icon>
                      {{ iconPart }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("page.race-scores.select-all") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 1">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ inputs.participant.length - 1 }}) {{ $t("common.form.select-participants") }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="6" class="d-flex" cols="12" sm="4">
            <v-autocomplete
              v-model="inputs.class"
              :items="classes"
              :multiple="true"
              :clearable="true"
              :small-chips="true" dense
              @change="filteredScores_()" hide-details
              :label="$tc('common.form.class')"
              outlined>
              <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @click="selectAllClass">
                  <v-list-item-action>
                    <v-icon>
                      {{ iconClass }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("page.race-scores.select-all") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text caption">
                  (+{{ inputs.class.length - 3 }}) {{ $t("common.form.select-class") }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col md="6" class="d-flex" cols="12" sm="4">
            <v-autocomplete
              v-model="inputs.section"
              :items="sections"
              :multiple="true"
              :clearable="true" hide-details
              :small-chips="true" dense
              @change="filteredScores_()"
              :label="$tc('common.form.section')"
              outlined>
              <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @click="selectAllSections">
                  <v-list-item-action>
                    <v-icon>
                      {{ iconSection }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("page.race-scores.select-all") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text caption">
                  (+{{ inputs.section.length - 3 }}) {{ $t("common.form.select-section") }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="d-flex" md="6" cols="12" sm="12">
            <v-select
              :label="$tc('page.race-scores.column-selection')"
              v-model="column"
              :items="column_items" hide-details
              item-text="text"
              item-value="id"
              persistent-hint
              :multiple="true"
              :outlined="true"
              @change="columnSelection()"
              dense>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >
                  (+{{ column.length - 1 }} {{ $t("page.race-scores.others") }})
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex" md="2" cols="12" sm="12">
            <v-btn class="ma-2" color="secondary" width="100%">
              {{ $t("page.race-scores.add-score") }}
            </v-btn>
          </v-col>
          <v-col class="d-flex" md="2" cols="12" sm="12">
            <v-btn @click="launchScore" class="ma-2" color="secondary" width="100%">
              {{ $t("page.race-scores.score") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex" cols="12" sm="12" style="position:relative;" >
            <VueTabulator
              ref="tabulator"
              v-model="filteredScores"
              :options="tabulatorOptions"
              style="width: 100%"
            />
            <div v-if="!isLoadData"
              style='position: absolute;
                    left: 40%;
                    top: 57%;border:4px solid #333; border-radius:10px; background:#fff; font-weight:bold; font-size:16px; color:#000; padding:10px 20px;'>
                    {{ $t("page.race-scores.loading")}}

            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import axios from "axios";

export default {
  mixins: [apiCalls],
  components: {},
  data() {
    return {
      column_items: [],
      column: [],
      title: "",
      participants: [],
      classes: [],
      sections:[],
      inputs: {
        participant: [],
        class: [],
        section:[]
      },
      filteredScores: [],
      /*tabulatorOptions: {
        placeholder: this.$t("common.table.no-data"),
        tooltips: true,
        addRowPos: "top",
        height: "600",
        layout: "fitColumns",
        resizableColumns: true,
        columns: [
          {
            title: this.$t("common.table.first-name"),
            field: "firstName",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.last-name"),
            field: "lastName",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.number"),
            field: "displayedNumber",
            visible: true,
            width: "40",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            validator:["required","regex:^[A-Za-z0-9]+$"],
            cellEdited: this.numberEdited
          },
          {
            title: this.$t("common.table.class"),
            field: "name",
            width: "150",
            visible: true,
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"select",
            editorParams: {},
            cellEdited: this.classEdited
          },
          {
            title: this.$t("common.table.section-name"),
            field: "sectionName",
            visible: true,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"select",
            editorParams: {},
            cellEdited: this.sectionEdited
          },
          {
            title: this.$t("common.table.classPosition"),
            field: "classPosition",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.classBehindBy"),
            field: "classBehindBy",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.overallPosition"),
            field: "overallPosition",
            width: "50",
            visible: false,
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.overallBehindBy"),
            field: "overallBehindBy",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.groupPosition"),
            field: "groupPosition",
            visible: false,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.sectionClassPosition"),
            field: "sectionClassPosition",
            visible: false,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.sectionOverallPosition"),
            field: "sectionOverallPosition",
            visible: false,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.checkNumberIn"),
            field: "checkNumberIn",
            visible: true,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.readTimeIn"),
            field: "readTimeIn",
            visible: true,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            editorParams: {},
            validator: ["required","regex:([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]"],
            cellEdited: this.readTimeInEdited
          },
          {
            title: this.$t("common.table.keyTimeIn"),
            field: "keyTimeIn",
            visible: true,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.earlyPenaltyIn"),
            field: "earlyPenaltyIn",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.earlyPenaltyOut"),
            field: "earlyPenaltyOut",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.latePenaltyIn"),
            field: "latePenaltyIn",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.checkNumberOut"),
            field: "checkNumberOut",
            visible: true,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.deviceNameIn"),
            field: "deviceNameIn",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.deviceNameOut"),
            field: "deviceNameOut",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          { title: this.$t("common.table.readTimeOut"),
            field: "readTimeOut",
            visible: true,
            width: "90",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            editorParams: {},
            validator: ["required","regex:([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]"],
            cellEdited: this.readTimeOutEdited
          },
          {
            title: this.$t("common.table.keyTimeOut"),
            field: "keyTimeOut",
            visible: true,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.latePenaltyOut"),
            field: "latePenaltyOut",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.isDisqualified"),
            field: "isDisqualified",
            visible: false,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.totalTimeSection"),
            field: "totalTimeSection",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.totalCumulatedTime"),
            field: "totalCumulatedTime",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.totalCumulatedPenalty"),
            field: "totalCumulatedPenalty",
            visible: false,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.sectionsCompleted"),
            field: "sectionsCompleted",
            visible: false,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.isThrown"),
            field: "isThrown",
            visible: false,
            width: "35",
            formatter: function (cell) {
              let value = cell.getValue();
              return value !== null
                ? (value === 1 ? '<i style="color:red;" class="fad fa-toilet"></i>'
                : '<i style="color:green;" class="fad fa-toilet"></i>') : ''
            },
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.actions"),
            field: "actions",
            visible: true,
            width: "100",
            headerVertical:'flip',
            columns: [
              {
                title: "",
                field: "edit",
                width: "40",
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-edit'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  cell.getRow().getData();
                }.bind(this),
              },
              {
                title: "",
                field: "delete",
                width: "40",
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-trash'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  cell.getRow().getData();
                }.bind(this),
              },
            ],
          },
        ]
      },*/
      participantsId: [],
      isLoadData: false,
      mode: 0,
      submode: '',
      classesEditor: [],
      sectionsEditor: [],
      columnsD:[],
    };
  },
  created() {
    this.loadParticipants();
    this.loadSections();
    this.loadTitleRace();
    this.loadColumns();
  },
  methods: {
    async launchScore(){
      const resp = await this.getApi("/api/v1/promoter/forceScore/"+this.$route.params.id);

      if(resp.rescore) {
        this.launchScore();
        // Update data
        //this.filteredScores_();
      }
      this.filteredScores_();
    },
    async numberEdited(cell){
      let _data = cell._cell.row.data;
      let data = {
        id: _data.fkParticipantsId,
        number: cell._cell.value
      }
      const response =  await this.putApi("/api/v1/promoter/race/participantScores/number", data);

      if(response.success == 1){
        this.filteredScores_();
      }
    },
    async classEdited(cell){
      let _data = cell._cell.row.data;
      let classId = cell._cell.value;

      let data = {
        id: _data.fkParticipantsId,
        classId: classId
      }

      const response =  await this.putApi("/api/v1/promoter/race/participantScores/class", data);

      if(response.success == 1){
        //await this.getApi("/api/v1/promoter/score/"+this.$route.params.id);
        this.filteredScores_();
      }
    },
    async sectionEdited(cell){
      let _data = cell._cell.row.data;
      let sectionId = cell._cell.value;

      let data = {
        participant_id: _data.fkParticipantsId,
        section_id: sectionId,
        section_id_old: _data.fkRaceSectionsId
      }

      const response =  await this.putApi("/api/v1/promoter/race/participantScores/section", data);

      if(response.success == 1){
        this.filteredScores_();
      }
    },
    async readTimeInEdited(cell){
      let _data = cell._cell.row.data;
      let data = {
        id: _data.fkParticipantsId,
        time: cell._cell.value,
        sectionId: _data.fkRaceSectionsId,
        field: 'in',
        idParticipantRaceSectionScores: _data.id,
        oldScoreTime: cell._cell.oldValue
      }
      const response =  await this.putApi("/api/v1/promoter/race/participantScores/time", data);

      if(response.success == 1){
        //await this.getApi("/api/v1/promoter/score/"+this.$route.params.id);
        this.filteredScores_();
      }
    },
    async readTimeOutEdited(cell){
      let _data = cell._cell.row.data;
      let data = {
        id: _data.fkParticipantsId,
        time: cell._cell.value,
        sectionId: _data.fkRaceSectionsId,
        field: 'out',
        idParticipantRaceSectionScores: _data.id,
        oldScoreTime: cell._cell.oldValue
      }
      const response =  await this.putApi("/api/v1/promoter/race/participantScores/time", data);

      if(response.success == 1){
        //await this.getApi("/api/v1/promoter/score/"+this.$route.params.id);
        this.filteredScores_();
      }
    },
    selectAllPart() {
      this.$nextTick(() => {
        if (this.likesAllPart) {
          this.inputs.participant = []
        } else {
          this.participants.forEach(elem =>{
            this.inputs.participant.push(elem.value);
          })
        }
        this.filteredScores_();
      });
    },
    selectAllClass() {
      this.$nextTick(() => {
        if (this.likesAllClass) {
          this.inputs.class = []
        } else {
          this.classes.forEach(elem =>{
            this.inputs.class.push(elem.value);
          })
        }
        this.filteredScores_();
      });
    },
    selectAllSections() {
      this.$nextTick(() => {
        if (this.likesAllSections) {
          this.inputs.section = []
        } else {
          this.sections.forEach(elem =>{
            this.inputs.section.push(elem.value);
          })
        }
        this.filteredScores_();
      });
    },
    columnSelection(){
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      let col_news = [];
      for(var i = 0; i < this.column_items.length; i++){

        var findColumn = this.column.find(
          element => element == i
        );

        if(findColumn != undefined){
          col_news.push(this.column_items[i].field);
          tabulatorInstance.showColumn(this.column_items[i].field);
        } else {
          //delete item if exist in columnsD
          tabulatorInstance.hideColumn(this.column_items[i].field);
        }
      }
      this.columnsD = col_news;
      let obj = {
          id: this.$route.params.id,
          columns: this.columnsD
        }
      localStorage.setItem("columns_defaults", JSON.stringify(obj));
    },
    loadColumns(){
      this.column_items = [
          {
            id: 0,
            text: this.$t("common.table.first-name"),
            field: "firstName"
          },
          {
            id: 1,
            text: this.$t("common.table.last-name"),
            field: "lastName"
          },
          {
            id: 2,
            text: this.$t("common.table.number"),
            field: "displayedNumber"
          },
          {
            id: 3,
            text: this.$t("common.table.class"),
            field: "name"
          },
          {
            id: 4,
            text: this.$t("common.table.section-name"),
            field: "sectionName"
          },
          {
            id: 5,
            text: this.$t("common.table.classPosition"),
            field: "classPosition"
          },
          {
            id: 6,
            text: this.$t("common.table.classBehindBy"),
            field: "classBehindBy"
          },
          {
            id: 7,
            text: this.$t("common.table.overallPosition"),
            field: "overallPosition"
          },
          {
            id: 8,
            text: this.$t("common.table.overallBehindBy"),
            field: "overallBehindBy"
          },
          {
            id: 9,
            text: this.$t("common.table.groupPosition"),
            field: "groupPosition"
          },
          {
            id: 10,
            text: this.$t("common.table.sectionClassPosition"),
            field: "sectionClassPosition"
          },
          {
            id: 11,
            text: this.$t("common.table.sectionOverallPosition"),
            field: "sectionOverallPosition"
          },
          {
            id: 12,
            text: this.$t("common.table.checkNumberIn"),
            field: "checkNumberIn"
          },
          {
            id: 13,
            text: this.$t("common.table.readTimeIn"),
            field: "readTimeIn"
          },
          {
            id: 14,
            text: this.$t("common.table.keyTimeIn"),
            field: "keyTimeIn"
          },
          {
            id:15,
            text: this.$t("common.table.earlyPenaltyIn"),
            field: "earlyPenaltyIn"
          },
          {
            id:16,
            text: this.$t("common.table.earlyPenaltyOut"),
            field: "earlyPenaltyOut"
          },
          {
            id: 17,
            text: this.$t("common.table.latePenaltyIn"),
            field: "latePenaltyIn"
          },
          {
            id: 18,
            text: this.$t("common.table.checkNumberOut"),
            field: "checkNumberOut"
          },
          {
            id: 19,
            text: this.$t("common.table.deviceNameIn"),
            field: "deviceNameIn"
          },
          {
            id: 20,
            text: this.$t("common.table.deviceNameOut"),
            field: "deviceNameOut"
          },
          {
            id: 21,
            text: this.$t("common.table.readTimeOut"),
            field: "readTimeOut"
          },
          {
            id: 22,
            text: this.$t("common.table.keyTimeOut"),
            field: "keyTimeOut"
          },
          {
            id: 23,
            text: this.$t("common.table.latePenaltyOut"),
            field: "latePenaltyOut"
          },
          {
            id: 24,
            text: this.$t("common.table.isDisqualified"),
            field: "isDisqualified"
          },
          {
            id: 25,
            text: this.$t("common.table.totalTimeSection"),
            field: "totalTimeSection"
          },
          {
            id: 26,
            text: this.$t("common.table.totalCumulatedTime"),
            field: "totalCumulatedTime"
          },
          {
            id: 27,
            text: this.$t("common.table.totalCumulatedPenalty"),
            field: "totalCumulatedPenalty"
          },
          {
            id: 28,
            text: this.$t("common.table.sectionsCompleted"),
            field: "sectionsCompleted"
          },
          {
            id: 29,
            text: this.$t("common.table.isThrown"),
            field: "isThrown"
          }
        ];
    },
    async filteredScores_() {
      this.isLoadData = false;
      let data= {};
      data.participants = this.inputs.participant;
      data.class = this.inputs.class;
      data.section = this.inputs.section;
      data.raceId = this.$route.params.id;

      localStorage.setItem("filters_participant_scores", JSON.stringify(data));
      const response =  await this.postApi("/api/v1/promoter/race/participantScores/"+this.$route.params.id, data);
      this.filteredScores = response.message.map((el) => {
          el.checkNumberIn = el.checkNumber.in ? el.checkNumber.in.checkNumber: '';
          el.checkNumberOut = el.checkNumber.out ? el.checkNumber.out.checkNumber: '';
          return el;
      });
      this.isLoadData = true;
    },
    async loadTitleRace(){
      let data = {};

      data.raceId = this.$route.params.id;
      data.force = false

      const response = await this.api("post", "/api/v1/promoter/race", data);

      this.title = response.message.raceName;
      this.mode = response.message.mode;
      this.submode = response.message.subMode;
      let columns_defaults = localStorage.getItem("columns_defaults");

      if(columns_defaults != null){
        let _def = JSON.parse(columns_defaults);
        if(_def.id == this.$route.params.id) this.columnsD = _def.columns;
        else {
          this.columnsD = ['firstName','lastName','displayedNumber','name','sectionName','checkNumberIn','readTimeIn','checkNumberOut','readTimeOut'];
          this.columnsD = ['firstName','lastName','displayedNumber','name','sectionName','checkNumberIn','readTimeIn','checkNumberOut','readTimeOut'];
          let obj = {
            id: this.$route.params.id,
            columns: this.columnsD
          }
          localStorage.setItem("columns_defaults", JSON.stringify(obj));
        }
      }else{
        this.columnsD = ['firstName','lastName','displayedNumber','name','sectionName','checkNumberIn','readTimeIn','checkNumberOut','readTimeOut'];
        let obj = {
          id: this.$route.params.id,
          columns: this.columnsD
        }
        localStorage.setItem("columns_defaults", JSON.stringify(obj));
      }
      let dd = this.columnsD;
      let _columns = [];
      this.tabulatorOptions.columns.find(x => x.field == 'name').editorParams = { values: this.classesEditor }
      this.tabulatorOptions.columns.find(x => x.field == 'sectionName').editorParams = { values: this.sectionsEditor }

      if(this.mode == 10 && this.submode.toLowerCase() == 'restart'){
        this.tabulatorOptions.columns.forEach(function(col,index){
          if(dd.includes(col.field)){
            col.visible = true;
            _columns.push({
              id: index,
              text: col.title,
              field: col.field
            });
          }
          else col.visible = false;
        });
        this.column = _columns;
      }else{
        this.column = [
          {
            id: 2,
            text: this.$t("common.table.number"),
            field: "displayedNumber"
          },
          {
            id: 3,
            text: this.$t("common.table.class"),
            field: "name"
          },
          {
            id: 4,
            text: this.$t("common.table.section-name"),
            field: "sectionName"
          },
          {
            id: 5,
            text: this.$t("common.table.classPosition"),
            field: "classPosition"
          },
          {
            id: 6,
            text: this.$t("common.table.checkNumberIn"),
            field: "checkNumberIn"
          },
          {
            id: 7,
            text: this.$t("common.table.readTimeIn"),
            field: "readTimeIn"
          },
          {
            id: 14,
            text: this.$t("common.table.keyTimeIn"),
            field: "keyTimeIn"
          },
          {
            id: 17,
            text: this.$t("common.table.latePenaltyIn"),
            field: "latePenaltyIn"
          },
          {
            id: 18,
            text: this.$t("common.table.checkNumberOut"),
            field: "checkNumberOut"
          },
          { id: 21,
            text: this.$t("common.table.readTimeOut"),
            field: "readTimeOut"
          },
          {
            id: 22,
            text: this.$t("common.table.keyTimeOut"),
            field: "keyTimeOut"
          },
          {
            id: 23,
            text: this.$t("common.table.latePenaltyOut"),
            field: "latePenaltyOut"
          }
        ];
      }
    },
    loadSections(){
      this.sections = [];
      axios.get(`${this.root}/laravel/public/api/v1/livelaps/race/config/${this.$route.params.id}`).then(response =>{
        let data = response.data.sections.data;
        let data_class = response.data.classes.data;
        if(response.data.sections.success == 1){
          const _sections = data.map((elem) => {
            return {
              text: elem.sectionName,
              value: elem.id,
            };
          });
          const _sections_editor = data.map((elem) => {
            return {
              label: elem.sectionName,
              value: elem.id,
            };
          });
          this.sectionsEditor = _sections_editor;
          this.sections = _sections;
        }
        if(response.data.classes.success == 1){
          const _classes = data_class.map((elem) => {
            return {
              text: elem.name,
              value: elem.id,
              sortOrder: elem.sortOrder
            };
          });
          const _classes_ed = data_class.map((elem) => {
            return {
              label: elem.name,
              value: elem.id
            };
          });
           this.classesEditor = _classes_ed;
           this.classes = _classes;
           this.selectClassDefault(0);
        }
      }).catch(
          function(error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );
    },
    async loadParticipants() {
      this.participants = [];

      axios
        .get(
          `${this.root}/laravel/public/api/v1/promoter/race/loadParticipants/${this.$route.params.id}`
        )
        .then((response) => {
          const {
            data: {
              message: { data },
            },
          } = response;
          const _participants = data.map((elem) => {
            return {
              //{Number},{Class}, {Last Name, First Name}
              text: `${elem.displayedNumber}, ${elem.className}, ${elem.lName}, ${elem.fName}`,
              value: elem.id,
              className: elem.className,
              classId: elem.classId,
              participantId: elem.id,
            };
          });
          this.participants = _participants;

        });
    },
    selectClassDefault(n){
      let _class = this.classes.find(x => x.sortOrder == n);
      if(_class != undefined &&_class.value > 0){
        this.inputs.class.push(_class.value);
        //Get filters local and update data
        let _filterLocal = localStorage.getItem("filters_participant_scores");
        if(_filterLocal != null){
          _filterLocal = JSON.parse(_filterLocal);
          if(_filterLocal.raceId == this.$route.params.id){
            this.inputs.participant = _filterLocal.participants;
            this.inputs.class = _filterLocal.class;
            this.inputs.section = _filterLocal.section;
          }else{
            localStorage.removeItem("filters_participant_scores");
          }
        }
        this.filteredScores_();
      }else{
        this.selectClassDefault(n+1);
      }
    },
    printSelectedClasses() {
    },
  },
  computed: {
    likesAllPart () {
      return this.inputs.participant.length === this.participants.length
    },
    likesSomePart () {
      return this.inputs.participant.length > 0 && !this.likesAllPart
    },
    iconPart () {
      if (this.likesAllPart) return 'far fa-check-square'
      if (this.likesSomePart) return 'far fa-square'
      return 'far fa-square'
    },
    likesAllClass () {
      return this.inputs.class.length === this.classes.length
    },
    likesSomeClass () {
      return this.inputs.class.length > 0 && !this.likesAllClass
    },
    iconClass () {
      if (this.likesAllClass) return 'far fa-check-square'
      if (this.likesSomeClass) return 'far fa-square'
      return 'far fa-square'
    },
    likesAllSections () {
      return this.inputs.section.length === this.sections.length
    },
    likesSomeSections () {
      return this.inputs.section.length > 0 && !this.likesAllSections
    },
    iconSection () {
      if (this.likesAllSections) return 'far fa-check-square'
      if (this.likesSomeSections) return 'far fa-square'
      return 'far fa-square'
    },
    filteredParticipants() {
      if (this.inputs.class.length == 0) return this.participants;

      var participants = [];
      for (var i = 0; i < this.participants.length; i++) {
        if (this.inputs.class.includes(this.participants[i].classId)) {
          participants.push(this.participants[i]);
        }
      }

      return participants;
    }, 
    translateTabulator() {
      return {
        en: { data: { "no_data": this.$t("common.table.no-data","en") } },
        es: { data: { "no_data": this.$t("common.table.no-data","es") } },
        fr: { data: { "no_data": this.$t("common.table.no-data","fr") } }
      };
    },
    tabulatorOptions() {

      return {
        placeholder: this.$t("common.table.no-data"),
        tooltips: true,
        addRowPos: "top",
        height: "600",
        layout: "fitColumns",
        resizableColumns: true,
        columns: [
          {
            title: this.$t("common.table.first-name"),
            field: "firstName",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.last-name"),
            field: "lastName",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.number"),
            field: "displayedNumber",
            visible: true,
            width: "40",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            validator:["required","regex:^[A-Za-z0-9]+$"],
            cellEdited: this.numberEdited
          },
          {
            title: this.$t("common.table.class"),
            field: "name",
            width: "150",
            visible: true,
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"select",
            editorParams: {},
            cellEdited: this.classEdited
          },
          {
            title: this.$t("common.table.section-name"),
            field: "sectionName",
            visible: true,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"select",
            editorParams: {},
            cellEdited: this.sectionEdited
          },
          {
            title: this.$t("common.table.classPosition"),
            field: "classPosition",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.classBehindBy"),
            field: "classBehindBy",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.overallPosition"),
            field: "overallPosition",
            width: "50",
            visible: false,
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.overallBehindBy"),
            field: "overallBehindBy",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.groupPosition"),
            field: "groupPosition",
            visible: false,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.sectionClassPosition"),
            field: "sectionClassPosition",
            visible: false,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.sectionOverallPosition"),
            field: "sectionOverallPosition",
            visible: false,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.checkNumberIn"),
            field: "checkNumberIn",
            visible: true,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.readTimeIn"),
            field: "readTimeIn",
            visible: true,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            editorParams: {},
            validator: ["required","regex:([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]"],
            cellEdited: this.readTimeInEdited
          },
          {
            title: this.$t("common.table.keyTimeIn"),
            field: "keyTimeIn",
            visible: true,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.earlyPenaltyIn"),
            field: "earlyPenaltyIn",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.earlyPenaltyOut"),
            field: "earlyPenaltyOut",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.latePenaltyIn"),
            field: "latePenaltyIn",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.checkNumberOut"),
            field: "checkNumberOut",
            visible: true,
            width: "30",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.deviceNameIn"),
            field: "deviceNameIn",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.deviceNameOut"),
            field: "deviceNameOut",
            visible: true,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          { title: this.$t("common.table.readTimeOut"),
            field: "readTimeOut",
            visible: true,
            width: "90",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            editor:"input",
            editorParams: {},
            validator: ["required","regex:([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]"],
            cellEdited: this.readTimeOutEdited
          },
          {
            title: this.$t("common.table.keyTimeOut"),
            field: "keyTimeOut",
            visible: true,
            width: "70",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.latePenaltyOut"),
            field: "latePenaltyOut",
            visible: true,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.isDisqualified"),
            field: "isDisqualified",
            visible: false,
            width: "50",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.totalTimeSection"),
            field: "totalTimeSection",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.totalCumulatedTime"),
            field: "totalCumulatedTime",
            visible: false,
            width: "100",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.totalCumulatedPenalty"),
            field: "totalCumulatedPenalty",
            visible: false,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.sectionsCompleted"),
            field: "sectionsCompleted",
            visible: false,
            width: "35",
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.isThrown"),
            field: "isThrown",
            visible: false,
            width: "35",
            formatter: function (cell) {
              let value = cell.getValue();
              return value !== null
                ? (value === 1 ? '<i style="color:red;" class="fad fa-toilet"></i>'
                : '<i style="color:green;" class="fad fa-toilet"></i>') : ''
            },
            headerVertical:'flip',
            headerFilter: "input",
            headerFilterPlaceholder: " ",
          },
          {
            title: this.$t("common.table.actions"),
            field: "actions",
            visible: true,
            width: "100",
            headerVertical:'flip',
            columns: [
              {
                title: "",
                field: "edit",
                width: "40",
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-edit'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  cell.getRow().getData();
                }.bind(this),
              },
              {
                title: "",
                field: "delete",
                width: "40",
                hozAlign: "center",
                headerSort: false,
                formatter: function () {
                  return "<i class='fa fa-trash'></i>";
                }.bind(this),
                cellClick: function (e, cell) {
                  cell.getRow().getData();
                }.bind(this),
              },
            ],
          },
        ]
      };
    }
  },
};
</script>

<style lang="scss">
/*Tabulator styles*/
.tabulator-col[tabulator-field="edit"],
.tabulator-col[tabulator-field="edit"],
.tabulator-col-group-cols {
  height: 0px !important;
  min-height: 0px !important;
}
.tabulator-col[tabulator-field="edit"],
.tabulator-col[tabulator-field="edit"] {
  border: 0px !important;
}
.tabulator-menu {
    height: 300px;
    position: absolute;
    display: inline-block;
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #aaa;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    font-size: 14px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 10000;
}
.tabulator-menu .tabulator-menu-item {
    position: relative;
    box-sizing: border-box;
    padding: 5px 10px;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.tabulator-menu-item i {
    color: #3FB449;
}
.tabulator .tabulator-header .tabulator-col {
  display: inline-block;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-right: 1px solid #aaa;
  background-color: #222;
  text-align: left;
  vertical-align: bottom;
  overflow: hidden;
  height: auto !important;
}
/*end tabulator styles */
</style>
